import { getNodesBounds, getViewportForBounds, Node, Viewport } from 'reactflow';

export const AI_BUILDER_PANEL_WIDTH = 386;
const AI_BUILDER_PANEL_GAP = 2;
export const AI_BUILDER_CONTROLS_LEFT = 16;
export const AI_BUILDER_CONTROLS_SHIFT = AI_BUILDER_PANEL_WIDTH + AI_BUILDER_PANEL_GAP;
export const AI_BUILDER_VIEWPORT_SHIFT = AI_BUILDER_PANEL_WIDTH / 2;
export const AI_BUILDER_PANEL_ANIMATION_SECONDS = 0.2;
export const AI_BUILDER_VIEWPORT_ANIMATION_MS = 200;
const FIT_VIEW_PADDING = 0.1;

type FitViewWithOffsetParams = {
  nodes: Node[];
  viewportWidth: number;
  viewportHeight: number;
  minZoom: number;
  maxZoom: number;
  offsetX: number;
  duration?: number;
  padding?: number;
  setViewport: (viewport: Viewport, options?: { duration?: number }) => void;
};

export const fitViewWithOffset = ({
  nodes,
  viewportWidth,
  viewportHeight,
  minZoom,
  maxZoom,
  offsetX,
  duration,
  padding = FIT_VIEW_PADDING,
  setViewport,
}: FitViewWithOffsetParams) => {
  if (!viewportWidth || !viewportHeight) return;
  const visibleNodes = nodes.filter((node) => !node.hidden);
  if (!visibleNodes.length) return;

  const bounds = getNodesBounds(visibleNodes);
  const viewport = getViewportForBounds(
    bounds,
    viewportWidth,
    viewportHeight,
    minZoom,
    maxZoom,
    padding
  );

  setViewport({ ...viewport, x: viewport.x + offsetX }, duration ? { duration } : undefined);
};
